<template>
  <PageWrap page-title="Encargos">
    <div class="charges-list-container">
      <div>
        <BfButtonGroup
          :active-options="filter.status"
          :options="statusFilterButtonOptions"
          class="charge-status-filter mb-3"
          @click-option="updateStatusFilter"
        />

        <div class="header-tools-wrap mb-3">
          <div class="header-filters-wrap">
            <div class="header-filters-row">
              <div class="header-filter">
                <BfInput
                  :value="filter.code"
                  data-key="code"
                  placeholder="Código (ID)"
                  :left-border="false"
                  :display-label="false"
                  :bottom-gutter="false"
                  size="medium"
                  @update="updateSearch"
                />
              </div>
              <div class="header-filter">
                <BfInput
                  :value="filter.chargeNumber"
                  data-key="chargeNumber"
                  placeholder="Nº encargo"
                  :left-border="false"
                  :display-label="false"
                  :bottom-gutter="false"
                  size="medium"
                  @update="updateSearch"
                />
              </div>
              <div class="header-filter">
                <BfInput
                  :value="filter.valtin"
                  data-key="valtin"
                  placeholder="Valtin"
                  :left-border="false"
                  :display-label="false"
                  :bottom-gutter="false"
                  size="medium"
                  @update="updateSearch"
                />
              </div>
              <div class="header-filter">
                <BfInput
                  :value="filter.branch"
                  data-key="branch"
                  placeholder="Sucursal"
                  :left-border="false"
                  :display-label="false"
                  :bottom-gutter="false"
                  size="medium"
                  @update="updateSearch"
                />
              </div>
              <div class="header-filter">
                <BfInput
                  :value="filter.loanNumber"
                  data-key="loanNumber"
                  placeholder="Nº de Prestamo"
                  :left-border="false"
                  :display-label="false"
                  :bottom-gutter="false"
                  size="medium"
                  @update="updateSearch"
                />
              </div>
              <div class="header-filter">
                <BfInput
                  :value="filter.applicant"
                  data-key="applicant"
                  placeholder="Solicitante"
                  :left-border="false"
                  :display-label="false"
                  :bottom-gutter="false"
                  size="medium"
                  @update="updateSearch"
                />
              </div>
              <div class="header-filter">
                <BfInput
                  :value="filter.dni"
                  data-key="dni"
                  placeholder="DNI/CIF Solicitante"
                  :left-border="false"
                  :display-label="false"
                  :bottom-gutter="false"
                  size="medium"
                  @update="updateSearch"
                />
              </div>

              <!--  <div class="header-filter">
                <BfInput
                  :value="filter.registro"
                  data-key="registro"
                  placeholder="Registro"
                  :left-border="false"
                  :display-label="false"
                  :bottom-gutter="false"
                  size="medium"
                  @update="updateSearch"
                />
              </div>-->
              <!--  <div class="header-filter">
                <BfInput
                  :value="filter.finca"
                  data-key="finca"
                  placeholder="Finca"
                  :left-border="false"
                  :display-label="false"
                  :bottom-gutter="false"
                  size="medium"
                  @update="updateSearch"
                />
              </div>-->
              <div class="header-filter">
                <BfInput
                  :value="filter.finalidad"
                  data-key="finalidad"
                  placeholder="Finalidad"
                  :left-border="false"
                  :display-label="false"
                  :bottom-gutter="false"
                  size="medium"
                  @update="updateSearch"
                />
              </div>
              <div class="header-filter">
                <!--    <BfInput
                  :value="filter.poblacion"
                  data-key="poblacion"
                  placeholder="Población"
                  :left-border="false"
                  :display-label="false"
                  :bottom-gutter="false"
                  size="medium"
                  @update="updateSearch"
                /> -->
                <BfInput
                  :value="filter.expediente"
                  data-key="expediente"
                  placeholder="expediente"
                  :left-border="false"
                  :display-label="false"
                  :bottom-gutter="false"
                  size="medium"
                  @update="updateSearch"
                />
              </div>
              <div class="header-filter">
                <BfInput
                  :value="filter.direccion"
                  data-key="direccion"
                  placeholder="Dirección"
                  :left-border="false"
                  :display-label="false"
                  :bottom-gutter="false"
                  size="medium"
                  @update="updateSearch"
                />
              </div>

              <div class="header-filter">
                <BfInput
                  :value="filter.cadastralReference"
                  data-key="cadastralReference"
                  placeholder="Referencia Catastral"
                  :left-border="false"
                  :display-label="false"
                  :bottom-gutter="false"
                  size="medium"
                  @update="updateSearch"
                />
              </div>
              <div class="header-filter">
                <BfInput
                  :value="filter.delegation"
                  data-key="delegation"
                  placeholder="Empresa"
                  :left-border="false"
                  :display-label="false"
                  :bottom-gutter="false"
                  size="medium"
                  @update="updateSearch"
                />
              </div>

              <div class="header-filter">
                <BfInput
                  :value="filter.cliente"
                  data-key="cliente"
                  placeholder="Cliente"
                  :left-border="false"
                  :display-label="false"
                  :bottom-gutter="false"
                  size="medium"
                  @update="updateSearch"
                />
              </div>

              <div class="header-filter header-date-filter date-small">
                <BfDatePicker
                  v-if="!isStatusN"
                  :value="filter.dateRange"
                  data-key="dateRange"
                  start-placeholder="Fecha"
                  end-placeholder="Recep"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  :left-border="false"
                  :display-label="false"
                  size="medium"
                  @update="updateSearch"
                />
              </div>
              <div
                v-if="isStatusN || isStatusM"
                class="header-filter header-date-filter date-small"
              >
                <BfDatePicker
                  :value="filter.dateRangeFacturado"
                  data-key="dateRangeFacturado"
                  start-placeholder="Facturado"
                  end-placeholder="Fecha"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  :left-border="false"
                  :display-label="false"
                  size="medium"
                  @update="updateSearch"
                />
              </div>

              <div class="header-filter header-select-filter">
                <BfSelect
                  data-key="filterIncidencia"
                  :value="filterIncidencia"
                  :options="assessorSelectOptions"
                  @update="applySelectFilters"
                  placeholder="Incidencias"
                  :left-border="false"
                  :bottom-gutter="false"
                  :display-label="false"
                  size="medium"
                />
              </div>
              <div class="header-filter header-select-filter">
                <BfSelect
                  data-key="filterParalizados"
                  :value="filterParalizados"
                  :options="filtroParalizadosOptions"
                  @update="applyParalizadosFilter"
                  placeholder="Incidencias"
                  :left-border="false"
                  :bottom-gutter="false"
                  :display-label="false"
                  size="medium"
                />
              </div>

              <div class="header-filter header-date-filter date-small">
                <BfDatePicker
                  :value="filter.dateEntrega"
                  data-key="dateEntrega"
                  start-placeholder="Fecha"
                  end-placeholder="Entrega"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  :left-border="false"
                  :display-label="false"
                  size="medium"
                  @update="updateSearch"
                />
              </div>

              <div
                v-if="isStatusK"
                class="header-filter header-date-filter date-small"
              >
                <BfDatePicker
                  :value="filter.dateVisado"
                  data-key="dateVisado"
                  start-placeholder="Visado"
                  end-placeholder="Feha"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  :left-border="false"
                  :display-label="false"
                  size="medium"
                  @update="updateSearch"
                />
              </div>
              <div class="header-filter header-date-filter date-small">
                <button
                  class="btn btn-secondary btn-redondo"
                  @click="removeAllFilters"
                >
                  X
                </button>
              </div>
            </div>
          </div>
          <div v-if="isAdmin" class="header-new-button">
            <BfButton tag="router-link" :to="{ name: 'charge' }">
              Nuevo Encargo
            </BfButton>
          </div>
        </div>
      </div>

      <LoadingIndicator v-if="loadingData" />

      <div v-else class="charges-table-section">
        <div class="table-outer-wrap">
          <BfTable
            :data="charges"
            :columns="chargeTableColumns"
            :row-class-name="tableRowClassNames"
            header-cell-class-name="charges-table-header-cell"
            cell-class-name="charges-table-cell tasaciones-small-cell"
            stripe
            show-footer
            :per-page="perPage"
            :total-rows="totalRows"
            :current-page="filter.page"
            show-checkbox-column
            :checked-rows="checkedRows"
            :header-checkbox-checked="allTableRowsChecked"
            @row-click="clickTableRow"
            @row-checkbox-change="chargeTableRowCheckboxChange"
            @header-checkbox-change="chargesTableHeaderCheckboxChange"
            @sort-change="sortTable"
          >
            <template slot="advertencias" slot-scope="{ row }">
              <div
                v-if="row.advertencias !== null"
                class="text-center"
                style="margin-left: -4px"
              >
                <i
                  class="fas fa-exclamation-triangle fa-lg text-warning"
                  :title="row.advertencias"
                />
              </div>
            </template>

            <span slot="sucursal" slot-scope="{ row }">
              {{ row.sucursal && row.sucursal.sucursal }}
            </span>

            <template slot="urgente" slot-scope="{ row }">
              {{ row['urgente'] ? 'Si' : 'No' }}
            </template>

            <template
              slot="visita_exterior_texto"
              slot-scope="{ row, cellValue, column }"
            >
              <BfSelect
                :value="cellValue"
                data-key="inmueble_visita_exterior"
                edit-mode
                :options="chargesTableTrueFalseSelectOptions"
                :display-label="false"
                :left-border="false"
                :bottom-gutter="false"
                :placeholder="column.label"
                size="mini"
                class="charges-table-cell-input"
                @update="updateChargesTableCellInput($event, row)"
              />
            </template>

            <template
              slot="antecedente_texto"
              slot-scope="{ row, cellValue, column }"
            >
              <BfSelect
                :value="cellValue"
                data-key="inmueble_antecedente"
                edit-mode
                :options="chargesTableTrueFalseSelectOptions"
                :display-label="false"
                :left-border="false"
                :bottom-gutter="false"
                :placeholder="column.label"
                size="mini"
                class="charges-table-cell-input"
                @update="updateChargesTableCellInput($event, row)"
              />
            </template>

            <!-- "Terminados" editable columns -->

            <template
              v-if="isStatusI"
              slot="expediente"
              slot-scope="{ row, cellValue, column }"
            >
              <BfInput
                edit-mode
                data-key="expediente"
                :value="cellValue"
                :edit-mode-value="cellValue ? `${cellValue}` : null"
                :display-label="false"
                :left-border="false"
                :bottom-gutter="false"
                :placeholder="column.label"
                select-on-focus
                size="mini"
                class="charges-table-cell-input"
                @update="updateChargesTableCellInput($event, row)"
              />
            </template>

            <!-- "Visados" editable columns -->

            <template
              v-if="isStatusI || isStatusK"
              slot="valoracion_tasacion"
              slot-scope="{ row, cellValue, column }"
            >
              <BfInput
                edit-mode
                data-key="valoracion_tasacion"
                :value="cellValue"
                :edit-mode-value="
                  cellValue ? tablePriceFieldValueFormatter(cellValue) : null
                "
                :display-label="false"
                :left-border="false"
                :bottom-gutter="false"
                :placeholder="column.label"
                select-on-focus
                size="mini"
                class="charges-table-cell-input"
                @update="updateChargesTableCellInput($event, row)"
              />
            </template>
            <template
              v-if="isStatusK || isStatusM || isStatusI"
              slot="expediente"
              slot-scope="{ row, cellValue, column }"
            >
              <BfInput
                edit-mode
                data-key="expediente"
                :value="cellValue"
                :edit-mode-value="cellValue ? `${cellValue}` : null"
                :display-label="false"
                :left-border="false"
                :bottom-gutter="false"
                :placeholder="column.label"
                select-on-focus
                size="mini"
                class="charges-table-cell-input"
                @update="updateChargesTableCellInput($event, row)"
              />
            </template>

            <template
              v-if="isStatusI || isStatusK"
              slot="honorarios_tasacion"
              slot-scope="{ row, cellValue, column }"
            >
              <BfInput
                edit-mode
                data-key="honorarios_tasacion"
                :value="cellValue"
                :edit-mode-value="
                  cellValue ? tablePriceFieldValueFormatter(cellValue) : null
                "
                :display-label="false"
                :left-border="false"
                :bottom-gutter="false"
                :placeholder="column.label"
                select-on-focus
                size="mini"
                class="charges-table-cell-input"
                @update="updateChargesTableCellInput($event, row)"
              />
            </template>

            <template
              v-if="isStatusI || isStatusK"
              slot="facturacion_neta_porcentaje_honorarios"
              slot-scope="{ cellValue }"
            >
              {{ cellValue }}%
            </template>

            <template
              v-if="isStatusI || isStatusK"
              slot="gastos_desplazamiento"
              slot-scope="{ row, cellValue, column }"
            >
              <BfInput
                edit-mode
                data-key="gastos_desplazamiento"
                :value="cellValue"
                :edit-mode-value="
                  cellValue ? tablePriceFieldValueFormatter(cellValue) : null
                "
                :display-label="false"
                :left-border="false"
                :bottom-gutter="false"
                :placeholder="column.label"
                select-on-focus
                size="mini"
                class="charges-table-cell-input"
                @update="updateChargesTableCellInput($event, row)"
              />
            </template>

            <template
              v-if="isStatusI || isStatusK"
              slot="facturacion_neta"
              slot-scope="{ row, cellValue, column }"
            >
              <BfInput
                edit-mode
                data-key="facturacion_neta"
                :value="cellValue"
                :edit-mode-value="
                  cellValue ? tablePriceFieldValueFormatter(cellValue) : null
                "
                :display-label="false"
                :left-border="false"
                :bottom-gutter="false"
                :placeholder="column.label"
                select-on-focus
                size="mini"
                class="charges-table-cell-input"
                @update="updateChargesTableCellInput($event, row)"
              />
            </template>

            <template
              v-if="isStatusI || isStatusK || isStatusM"
              slot="fecha_visado"
              slot-scope="{ row, cellValue, column }"
            >
              <BfDatePicker
                edit-mode
                data-key="fecha_visado"
                :value="cellValue"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="dd/MM/yyyy"
                :editModeValue="tableDateFieldValueFormatter"
                :display-label="false"
                :left-border="false"
                :bottom-gutter="false"
                :placeholder="column.label"
                size="mini"
                class="charges-table-cell-input"
                @update="updateChargesTableCellInput($event, row)"
              />
            </template>

            <template
              v-if="isStatusK || isStatusM"
              slot="facturacion_neta_fecha"
              slot-scope="{ row, cellValue, column }"
            >
              <BfDatePicker
                edit-mode
                data-key="facturacion_neta_fecha"
                :value="cellValue"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="dd/MM/yyyy"
                :editModeValue="tableDateFieldValueFormatter"
                :display-label="false"
                :left-border="false"
                :bottom-gutter="false"
                :placeholder="column.label"
                size="mini"
                class="charges-table-cell-input"
                @update="updateChargesTableCellInput($event, row)"
              />
            </template>
            <template
              v-if="ifStatusH || isStatusK || isStatusF"
              slot="num_valoracion"
              slot-scope="{ row, cellValue, column }"
            >
              <BfInput
                edit-mode
                data-key="num_valoracion"
                :value="cellValue"
                :display-label="false"
                :left-border="false"
                :bottom-gutter="false"
                :placeholder="column.label"
                select-on-focus
                size="mini"
                class="charges-table-cell-input"
                @update="updateChargesTableCellInput($event, row)"
              />
            </template>
          </BfTable>

          <div class="mt-4 text-center">
            <BfPagination
              v-if="charges.length"
              :current-page="filter.page"
              :total="totalRows"
              :page-size="perPage"
              @current-change="updatePagination"
            />
          </div>
          <!-- Exportar a EXCEL -->
          <download-excel
            :before-generate="startDownloadExcel"
            :before-finish="finishDownloadExcel"
            :fetch="fetchData"
            class="btn btn-exportar"
            :fields="json_fields"
            worksheet
            :name="nameExcel"
            :title="nameExcel"
          >
            Exportar en EXCEL
          </download-excel>
          <i
            v-if="exportandoExcel"
            class="fas fa-spinner fa-spin fa-2x text-secondary"
          />
        </div>

        <transition name="slide-in-preview">
          <div v-if="displayTableSidebar" class="table-sidebar-wrap">
            <div class="mb-5" v-if="displayTasadoresSideTable">
              <BfTitle size="small" tag="h3" class="mb-3">Tasadores</BfTitle>

              <BfInput
                v-model="assesorsTableSearch"
                :suffix-icon="
                  !searchingAssessors ? 'el-icon-search' : 'el-icon-loading'
                "
                placeholder="Busca por clave"
                data-key="search-assesors"
                :left-border="false"
                :display-label="false"
                @update="updateAssesorsTableSearch"
              />

              <!-- max-height para la altura de tabla de tasadores. cambia ese valor a tu gusto.-->

              <BfTable
                :columns="assessorsTableColumns"
                :data="assessorsTableData"
                border
                :checked-rows="assessorsTableCheckedRows"
                show-checkbox-column
                :show-checkbox-column-header-checkbox="false"
                cell-class-name="tasaciones-small-cell"
                @row-checkbox-change="assessorTableRowCheckboxChange"
              />
            </div>

            <FileDropzone
              v-if="displaySidePreview"
              id="side_preview_dropzone"
              ref="sidePreviewDropzone"
              :options="dropOptions"
              @files-added="documentationFilesAdded"
            >
              <ChargeSidePreview
                :charge-data="selectedTableRowData"
                show-view-more
              />
            </FileDropzone>
          </div>
        </transition>
      </div>

      <FileFormModal
        :value="displayFileUploadModal"
        :categories="documentationCategories"
        :multiple-files="documentationUploadFiles.length > 1"
        :initial-form-data="documentationFormData"
        :is-uploading="documentationIsUploading"
        :form-errors="documentationFormErrors"
        :upload-size-progress="documentationSizeProgress"
        :upload-count-progress="documentationCountProgress"
        @save-data="saveDocumentationFileForm"
        @input="fileFormModalToggleVisibility"
      />

      <ChargeWarningModal
        v-model="displayChargeWarningFormModal"
        :form-errors="chargeWarningFormErrors"
        :warning-value="selectedChargeWarningValue"
        @save-data="updateChargeWarningModal"
      />

      <ScheduleVisitModal
        v-model="displayScheduleVisitModal"
        :form-data="scheduleVisitFormData"
        @update="scheduleChargeVisit"
      />

      <ChargesToolbar
        :visible="showChargesToolbar"
        :left-buttons="toolbarLeftButtons"
      >
        <template v-if="showToolbarRightButton" slot="right-buttons">
          <BfButton
            v-if="showNewIncidentButton"
            variant="orange"
            tag="router-link"
            :to="{
              name: 'incidencia',
              query: {
                chargeId: `${checkedRows[0]}`,
              },
            }"
          >
            Nueva Incidencia
          </BfButton>

          <BfButton
            v-if="showCreateRetentionButton"
            variant="orange"
            tag="router-link"
            :to="{
              name: 'retenido',
              query: {
                chargeId: `${checkedRows[0]}`,
              },
            }"
          >
            Nuevo Retenido
          </BfButton>

          <BfButton
            v-if="showCreateRevisionButton"
            variant="orange"
            tag="router-link"
            :to="{
              name: 'revision',
              query: {
                chargeId: `${checkedRows[0]}`,
              },
            }"
          >
            Nueva reclamación
          </BfButton>
        </template>
      </ChargesToolbar>
    </div>
  </PageWrap>
</template>

<script>
/* eslint-disable object-curly-newline, function-paren-newline */
import { mapState, mapGetters } from 'vuex';
import qsBinder from '@holamundo.app/vue-router-qs-binder';
import PageWrap from '@/components/PageWrap';
import FileDropzone from '@/components/FileDropzone';
import LoadingIndicator from '@/components/LoadingIndicator';
import ChargeSidePreview from '@/components/ChargeSidePreview';
import FileFormModal from '@/components/FormModals/FileFormModal';
import ChargeWarningModal from '@/components/FormModals/ChargeWarningModal';
import ScheduleVisitModal from '@/components/FormModals/ScheduleVisitModal';
import { assessorAPI, chargeAPI, documentAPI, visitAPI } from '@/api';
import { debounce, get, moment } from '@/utils';
import { uploadChargeDocuments } from '@/utils/abstract';

import ChargesToolbar from './ChargesToolbar';
import {
  aStatusColumns,
  bStatusColumns,
  cStatusColumns,
  dStatusColumns,
  eStatusColumns,
  fStatusColumns,
  gStatusColumns,
  hStatusColumns,
  iStatusColumns,
  jStatusColumns,
  kStatusColumns,
  mStatusColumns,
  lStatusColumns,
  nStatusColumns,
  assessorsTableColumns,
  TasadorRoleassessorsTableColumns,
  noFilterStatusColumns
} from './tableColumns';

const TASADOR_ALLOWED_FILTERS = ['C', 'L', 'D', 'F', 'G', 'H', 'J', 'N'];
const COLABORADOR_ALLOWED_FILTERS = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'N',
];

const updateMultipleChargeStatuses = (chargeIds, status) => {
  const requests = chargeIds.map(id =>
    chargeAPI.changeStatus({
      id,
      status: typeof status === 'string' ? status : status(id),
    }),
  );

  return Promise.all(requests);
};

const FILTER_PROPERTIES = {
  code: undefined,
  chargeNumber: undefined,
  valtin: undefined,
  branch: undefined,
  loanNumber: undefined,
  applicant: undefined,
  dni: undefined,
  registro: undefined,
  finca: undefined,
  cadastralReference: undefined,
  dateRange: undefined,
  dateRangeFacturado: undefined,
  dateEntrega: undefined,
  dateVisado: undefined,
  dateFacturado: undefined,
  status: undefined,
  finalidad: undefined,
  poblacion: undefined,
  expediente: undefined,
  direccion: undefined,
  cliente: undefined,
  page: 1,
};

export default {
  name: 'ChargesList',

  mixins: [
    qsBinder({
      dataKey: 'filter',
      data: ({ query }) =>
        Object.keys(FILTER_PROPERTIES).reduce((acc, key) => {
          const value = get(query, [key], FILTER_PROPERTIES[key]);

          const formattedValue = () => {
            switch (key) {
              case 'page':
                return Number(value);
              default:
                return value;
            }
          };

          return {
            ...acc,
            [key]: formattedValue(),
          };
        }, {}),
      debounceLength: 300,
      didUpdate: ($this) => {
        $this.loadChargesWithIndicator();
      },
    }),
  ],

  data() {
    return {
      exportandoExcel: false,
      chargeStatusCounts: [],
      charges: [],
      checkedRows: [],
      loadingData: false,
      perPage: 50,
      selectedRowId: null,
      totalRows: 0,
      activeFilterButtons: [],
      filterIncidencia: 4,
      filterParalizados: 0,
      tableSort: '',
      documentationCategories: [],
      documentationUploadFiles: [],
      documentationFormErrors: {},
      documentationCountProgress: {},
      documentationSizeProgress: {},
      documentationIsUploading: false,
      dropOptions: {
        url: 'https://holamundo.me/',
        autoQueue: false,
        autoProcessQueue: false,
        createImageThumbnails: false,
        clickable: false,
      },
      displayFileUploadModal: false,
      assessorSelectOptions: [
        {
          label: 'Todos',
          value: 3,
        },
        {
          label: 'Con incidencias',
          value: 1,
        },
        {
          label: 'Sin incidencias',
          value: 2,
        },
        {
          label: 'Solo activas',
          value: 4,
        },
      ],
      filtroParalizadosOptions: [
        {
          label: 'En Curso',
          value: 0,
        },
        {
          label: 'Paralizados',
          value: 1,
        },
        {
          label: 'Todos',
          value: '',
        },
      ],
      // Status "B" side table
      assessorsTableData: [],
      assessorsTableCheckedRows: [],
      assesorsTableSearch: '',
      searchingAssessors: false,

      // Charge warning editing
      displayChargeWarningFormModal: false,
      chargeWarningFormErrors: {},
      displayScheduleVisitModal: false,
      scheduleVisitFormData: {},
      // Excel default columns
      json_fields: {
        Cod: 'codigo',
        A: 'advertencias',
        NºEncargo: 'numero_encargo_formateado',
        FIN: 'inmueble_finalidad',
        'Tas Ofi': 'tasador_nombre',
        Estado: 'estado_texto',
        Doc: 'tiene_documentacion',
        'Vis Int': 'visita_exterior_texto',
        Ant: 'antecedente_texto',
        Exp: 'expediente',
        Valtin: 'num_valoracion',
        Emp: 'delegacion_nombre',
        Cli: 'empresa_cliente_nombre',
        'Tas Vis': 'tasador_encargado_codigo',
        'Tas Sal': 'tasador_salidas_codigo',
        'Tas Inc': 'tasador_incidencias_codigo',
        'Tas Rev': 'tasador_revision_codigo',
        'Tas Ret': 'tasador_retenido_codigo',
        'Tas Rec': 'tasador_revision_clave',
        'F. Encargo': 'fecha_hora_recepcion_texto',
        'F. Entrega': 'fecha_hora_limite_texto',
        Tra: 'tipo_trabajo_clave',
        Inm: 'tipo_inmueble_clave',
        Sucursal: 'sucursal.sucursal',
        CP: 'inmueble_codigopostal',
        Pob: 'inmueble_poblacion',
        Soli: 'solicitante_nombre',
      },
      // default name for excel
      nameExcel: 'Exportación sin ESTADO.xls',
      json_data: [
        {
          name: 'Tony Peña',
          city: 'New York',
          country: 'United States',
          birthdate: '1978-03-15',
          phone: {
            mobile: '1-541-754-3010',
            landline: '(541) 754-3010',
          },
        },
      ],
      ExportCharges: [],
    };
  },

  async created() {
    this.removeAllFilters();
    // TODO: Remove this once we have a dashboard page
    if (!this.roles.length) {
      return;
    }

    this.loadingData = true;
    try {
      await Promise.all([
        this.loadCharges(),
        this.loadAssessorsTableData(),
        this.loadDocumentCategories(),
        this.loadChargeStatusCounts(),
      ]);
    } finally {
      this.loadingData = false;
    }
  },

  methods: {
    startDownloadExcel() {
      this.exportandoExcel = true;
      // https://www.npmjs.com/package/vue-json-excel
    },
    finishDownloadExcel() {
      this.exportandoExcel = false;
    },
    /**
     * Lee del back los datos necesarios para preparar el excel, quitando, por ejemplo, la paginación.
     */
    async fetchData() {
      this.prepararColumnasExcel();

      const [from = undefined, to = undefined] = this.filter.dateRange || [];
      const [eFrom = undefined, eTo = undefined] = this.filter.dateEntrega || [];
      const [vFrom = undefined, vTo = undefined] = this.filter.dateVisado || []; //  filtro por fecha de visado
      const [fFrom = undefined, fTo = undefined] =
        this.filter.dateRangeFacturado || [];
      const { key = null, order } = this.tableSort;
      const data = await chargeAPI.exportAll({
        filterStatus: this.filter.status,
        from,
        include: 'solicitante,sucursal,delegacion,empresaCliente,visitas',
        page: this.filter.page,
        search: this.filter.chargeNumber,
        code: this.filter.code,
        filterValtin: this.filter.valtin,
        filterBranch: this.filter.branch,
        filterLoanNumber: this.filter.loanNumber,
        filterApplicantName: this.filter.applicant,
        filterRegistro: this.filter.registro,
        filterFinca: this.filter.finca,
        filterCadastralReference: this.filter.cadastralReference,
        filterExpediente: this.filter.updateSearch,
        filterFinalidad: this.filter.finalidad,
        filterDireccion: this.filter.direccion,
        filterDelegationName: this.filter.delegation,
        filterApplicantNif: this.filter.dni,
        incidencia: this.filterIncidencia,
        filterCliente: this.filter.cliente,
        filterEntrega: this.filter.dateEntrega,
        to,
        fFrom,
        fTo,
        eTo,
        eFrom,
        vFrom,
        vTo,
        sort: key ? `${order === 'descending' ? '-' : ''}${key}` : '',
      });

      return data.data;
    },

    /**
     * Este método gestiona las columnas del EXCEL.
     */
    prepararColumnasExcel() {
      // Estado Altas
      if (this.isStatusA) {
        /* Esto es para ver con Brad si se puede  arreglar */
        /* let columns = aStatusColumns.map(({ label, dataKey }) => ({
          [label]: dataKey
        }));
        columns =this.toObject(columns);
        console.log(columns);
        this.json_fields = columns; */

        this.nameExcel = `Export estado Altas TAES [${Date.now()}].xls`;
        this.json_fields = {
          Cod: 'codigo',
          A: 'advertencias',
          NºEncargo: 'numero_encargo_formateado',
          FIN: 'inmueble_finalidad',
          'Tas Ofi': 'tasador_nombre',
          Doc: {
            field: 'tiene_documentacion',
            callback: (value) => {
              if (value) {
                return 'Si';
              }
              return 'No';
            },
          },
          'Vis Int': 'visita_exterior_texto',
          Ant: 'antecedente_texto',
          'Num Ant': 'inmueble_numantecedente',
          Empresa: 'delegacion_nombre',
          Cli: 'empresa_cliente_nombre',
          Solicitante: 'solicitante_nombre',
          Zona: 'zona_nombre',
          'F. Encargo': 'fecha_hora_recepcion_texto',
          'F. Entrega': 'fecha_hora_limite_texto',
          Tra: 'tipo_trabajo_clave',
          Inm: 'tipo_inmueble_clave',
          Sucursal: 'sucursal.sucursal',
          CP: 'inmueble_codigopostal',
          Dirección: 'inmueble_direccion',
        };
      }

      if (this.isStatusB) {
        this.nameExcel = `Export estado Asig Visitas TAES [${Date.now()}].xls`;
        this.json_fields = {
          Cod: 'codigo',
          A: 'advertencias',
          NºEncargo: 'numero_encargo_formateado',
          FIN: 'inmueble_finalidad',
          Estado: 'estado_texto',
          Doc: {
            field: 'tiene_documentacion',
            callback: (value) => {
              if (value) {
                return 'Si';
              }
              return 'No';
            },
          },
          'Vis Int ': 'visita_exterior_texto',
          'F. Encargo': 'fecha_hora_recepcion_texto',
          'F. Entrega': 'fecha_hora_limite_texto',
          Zona: 'zona_nombre',
          'Tas Zon': 'tasador_zona_clave',
          Población: 'inmueble_poblacion',
          Ant: 'antecedente_texto',
          'Num Ant': 'inmueble_numantecedente',
          Cli: 'empresa_cliente_nombre',
          'Tas Vis': 'tasador_encargado_codigo',
          'Tas Sal': 'tasador_salidas_codigo',
          'Tas Inc': 'tasador_incidencias_codigo',
          Tra: 'tipo_trabajo_clave',
          Inm: 'tipo_inmueble_clave',
          Sucursal: 'sucursal.sucursal',
          CP: 'inmueble_codigopostal',
        };
      }

      if (this.isStatusC) {
        this.nameExcel = `Export estado Visitas TAES [${Date.now()}].xls`;
        this.json_fields = {
          Cod: 'codigo',
          A: 'advertencias',
          NºEncargo: 'numero_encargo_formateado',
          FIN: 'inmueble_finalidad',
          Estado: 'estado_texto',
          'F. Entrega': 'fecha_hora_limite_texto',
          Doc: {
            field: 'tiene_documentacion',
            callback: (value) => {
              if (value) {
                return 'Si';
              }
              return 'No';
            },
          },
          'Vis Int ': 'visita_exterior_texto',
          Ant: 'antecedente_texto',
          Cli: 'empresa_cliente_nombre',
          'Tas Vis': 'tasador_encargado_codigo',
          'Tas Sal': 'tasador_salidas_codigo',
          Tra: 'tipo_trabajo_clave',
          Inm: 'tipo_inmueble_clave',
          Sucursal: 'sucursal.sucursal',
          CP: 'inmueble_codigopostal',
          Población: 'inmueble_poblacion',
        };
      }

      if (this.isStatusL) {
        this.nameExcel = `Export estado En Ruta TAES [${Date.now()}].xls`;

        this.json_fields = {
          Cod: 'codigo',
          A: 'advertencias',
          NºEncargo: 'numero_encargo_formateado',
          FIN: 'inmueble_finalidad',
          Estado: 'estado_texto',
          'Datos visita': 'visita_formateada',
          'F. Entrega': 'fecha_hora_limite_texto',
          'Tas Vis': 'tasador_encargado_codigo',
          'Tas Sal': 'tasador_salidas_codigo',
          'Tas Inc': 'tasador_incidencias_codigo',
          Doc: {
            field: 'tiene_documentacion',
            callback: (value) => {
              if (value) {
                return 'Si';
              }
              return 'No';
            },
          },
          'Vis Int ': 'visita_exterior_texto',
          Tra: 'tipo_trabajo_clave',
          Inm: 'tipo_inmueble_clave',
          Sucursal: 'sucursal.sucursal',
          CP: 'inmueble_codigopostal',
          Población: 'inmueble_poblacion',
        };
      }

      if (this.isStatusD) {
        this.nameExcel = `Export estado Incidencias TAES [${Date.now()}].xls`;

        this.json_fields = {
          Cod: 'codigo',
          A: 'advertencias',
          NºEncargo: 'numero_encargo_formateado',
          FIN: 'inmueble_finalidad',
          Estado: 'estado_texto',
          Doc: {
            field: 'tiene_documentacion',
            callback: (value) => {
              if (value) {
                return 'Si';
              }
              return 'No';
            },
          },
          'Vis Int ': 'visita_exterior_texto',
          Ant: 'antecedente_texto',
          'Num Ant': 'inmueble_numantecedente',
          Valtin: 'num_valoracion',
          Cli: 'empresa_cliente_nombre',
          'Tas Vis': 'tasador_encargado_codigo',
          'Tas Sal': 'tasador_salidas_codigo',
          'Tas Inc': 'tasador_incidencias_codigo',
          'F. Entrega': 'fecha_hora_limite_texto',
          Tra: 'tipo_trabajo_clave',
          Inm: 'tipo_inmueble_clave',
          Sucursal: 'sucursal.sucursal',
          CP: 'inmueble_codigopostal',
        };
      }

      if (this.isStatusE) {
        this.nameExcel = `Export estado Asig Salidas TAES [${Date.now()}].xls`;

        this.json_fields = {
          Cod: 'codigo',
          A: 'advertencias',
          NºEncargo: 'numero_encargo_formateado',
          FIN: 'inmueble_finalidad',
          Estado: 'estado_texto',
          'Datos visita': 'visita_formateada',
          'F. Entrega': 'fecha_hora_limite_texto',
          Doc: {
            field: 'tiene_documentacion',
            callback: (value) => {
              if (value) {
                return 'Si';
              }
              return 'No';
            },
          },
          'Vis Int ': 'visita_exterior_texto',
          Ant: 'antecedente_texto',
          Cli: 'empresa_cliente_nombre',
          'Tas Vis': 'tasador_encargado_codigo',
          'Tas Sal': 'tasador_salidas_codigo',
          'Tas Inc': 'tasador_incidencias_codigo',
          Tra: 'tipo_trabajo_clave',
          Inm: 'tipo_inmueble_clave',
          Sucursal: 'sucursal.sucursal',
          CP: 'inmueble_codigopostal',
          Población: 'inmueble_poblacion',
        };
      }

      if (this.isStatusF) {
        this.nameExcel = `Export estado Salidas TAES [${Date.now()}].xls`;
        this.json_fields = {
          Cod: 'codigo',
          A: 'advertencias',
          NºEncargo: 'numero_encargo_formateado',
          FIN: 'inmueble_finalidad',
          Estado: 'estado_texto',
          'Datos visita': 'visita_formateada',
          'F. Entrega': 'fecha_hora_limite_texto',
          Doc: {
            field: 'tiene_documentacion',
            callback: (value) => {
              if (value) {
                return 'Si';
              }
              return 'No';
            },
          },
          'Vis Int ': 'visita_exterior_texto',
          Ant: 'antecedente_texto',
          'Num Ant': 'inmueble_numantecedente',
          Valtin: 'num_valoracion',
          Cli: 'empresa_cliente_nombre',
          'Tas Vis': 'tasador_encargado_codigo',
          'Tas Sal': 'tasador_salidas_codigo',
          'Tas Inc': 'tasador_incidencias_codigo',
          'Tas Rev': 'tasador_revision_codigo',
          Tra: 'tipo_trabajo_clave',
          Inm: 'tipo_inmueble_clave',
          Sucursal: 'sucursal.sucursal',
          CP: 'inmueble_codigopostal',
          Población: 'inmueble_poblacion',
        };
      }

      if (this.isStatusG) {
        this.nameExcel = `Export estado Revisión TAES [${Date.now()}].xls`;
        this.json_fields = {
          Cod: 'codigo',
          A: 'advertencias',
          NºEncargo: 'numero_encargo_formateado',
          FIN: 'inmueble_finalidad',
          Estado: 'estado_texto',
          'F. Entrega': 'fecha_hora_limite_texto',
          Doc: {
            field: 'tiene_documentacion',
            callback: (value) => {
              if (value) {
                return 'Si';
              }
              return 'No';
            },
          },
          'Vis Int ': 'visita_exterior_texto',
          Ant: 'antecedente_texto',
          'Num Ant': 'inmueble_numantecedente',
          Valtin: 'num_valoracion',
          Cli: 'empresa_cliente_nombre',
          'Tas Vis': 'tasador_encargado_codigo',
          'Tas Sal': 'tasador_salidas_codigo',
          'Tas Inc': 'tasador_incidencias_codigo',
          'Tas Rev': 'tasador_revision_codigo',
          Tra: 'tipo_trabajo_clave',
          Inm: 'tipo_inmueble_clave',
          Sucursal: 'sucursal.sucursal',
          CP: 'inmueble_codigopostal',
          Población: 'inmueble_poblacion',
        };
      }

      if (this.ifStatusH) {
        this.nameExcel = `Export estado Enviar TAES [${Date.now()}].xls`;
        this.json_fields = {
          Cod: 'codigo',
          A: 'advertencias',
          NºEncargo: 'numero_encargo_formateado',
          FIN: 'inmueble_finalidad',
          Estado: 'estado_texto',
          'F. Entrega': 'fecha_hora_limite_texto',
          Doc: {
            field: 'tiene_documentacion',
            callback: (value) => {
              if (value) {
                return 'Si';
              }
              return 'No';
            },
          },
          'Vis Int ': 'visita_exterior_texto',
          Ant: 'antecedente_texto',
          'Num Ant': 'inmueble_numantecedente',
          Valtin: 'num_valoracion',
          Cli: 'empresa_cliente_nombre',
          'Tas Vis': 'tasador_encargado_codigo',
          'Tas Sal': 'tasador_salidas_codigo',
          'Tas Inc': 'tasador_incidencias_codigo',
          'Tas Rev': 'tasador_revision_codigo',
          'Tas Ret': 'tasador_retenido_codigo',
          Tra: 'tipo_trabajo_clave',
          Inm: 'tipo_inmueble_clave',
          Sucursal: 'sucursal.sucursal',
          CP: 'inmueble_codigopostal',
        };
      }
      if (this.isStatusI) {
        this.nameExcel = `Export estado Terminados TAES [${Date.now()}].xls`;
        this.json_fields = {
          Cod: 'codigo',
          A: 'advertencias',
          NºEncargo: 'numero_encargo_formateado',
          Estado: 'estado_texto',
          Doc: {
            field: 'tiene_documentacion',
            callback: (value) => {
              if (value) {
                return 'Si';
              }
              return 'No';
            },
          },
          'F. Entrega': 'fecha_hora_limite_texto',
          'F. Envio': 'fecha_hora_envio',
          'Valor Tas': 'valoracion_tasacion',
          'Honor Tas': 'honorarios_tasacion',
          'Vis Int ': 'visita_exterior_texto',
          Ant: 'antecedente_texto',
          'Num Ant': 'inmueble_numantecedente',
          Valtin: 'num_valoracion',
          Cli: 'empresa_cliente_nombre',
          'Tas Vis': 'tasador_encargado_codigo',
          'Tas Sal': 'tasador_salidas_codigo',
          'Tas Inc': 'tasador_incidencias_codigo',
          'Tas Rev': 'tasador_revision_codigo',
          'Tas Ret': 'tasador_retenido_codigo',
          Tra: 'tipo_trabajo_clave',
          Inm: 'tipo_inmueble_clave',
          Sucursal: 'sucursal.sucursal',
          CP: 'inmueble_codigopostal',
        };
      }
      if (this.isStatusJ) {
        this.nameExcel = `Export estado Retenidos TAES [${Date.now()}].xls`;
        this.json_fields = {
          Cod: 'codigo',
          A: 'advertencias',
          NºEncargo: 'numero_encargo_formateado',
          Estado: 'estado_texto',
          'F. Retenido': 'fecha_retenido',
          Doc: {
            field: 'tiene_documentacion',
            callback: (value) => {
              if (value) {
                return 'Si';
              }
              return 'No';
            },
          },
          'Tas Vis': 'tasador_encargado_codigo',
          'Tas Sal': 'tasador_salidas_codigo',
          'Tas Inc': 'tasador_incidencias_codigo',
          'Tas Ret': 'tasador_retenido_codigo',
          Exp: 'expediente',
          Valtin: 'num_valoracion',
          Cli: 'empresa_cliente_nombre',
          'Tas Ret': 'tasador_retenido_codigo',
          Tra: 'tipo_trabajo_clave',
          Inm: 'tipo_inmueble_clave',
        };
      }
      if (this.isStatusK) {
        this.nameExcel = `Export estado Visados TAES [${Date.now()}].xls`;
        this.json_fields = {
          Cod: 'codigo',
          NºEncargo: 'numero_encargo_formateado',
          Estado: 'estado_texto',
          'Valor Tas': 'valoracion_tasacion',
          'Honor Tas': 'honorarios_tasacion',

          Despl: 'gastos_desplazamiento',
          'Fac Neta': 'facturacion_neta',
          '% Fac Neta': 'facturacion_neta_porcentaje_honorarios',
          Exp: 'expediente',
          Valtin: 'num_valoracion',
          Cli: 'empresa_cliente_nombre',
          'Tas Vis': 'tasador_encargado_codigo',
          'Tas Sal': 'tasador_salidas_codigo',
          'Tas Inc': 'tasador_incidencias_codigo',
          'Tas Ret': 'tasador_retenido_codigo',
          Tra: 'tipo_trabajo_clave',
          Inm: 'tipo_inmueble_clave',
          'Fecha Visado': 'fecha_vistado',
          'Fecha Facturado': 'facturacion_neta_fecha',
        };
      }
      if (this.isStatusM) {
        this.nameExcel = `Export estado Facturado TAES [${Date.now()}].xls`;
        this.json_fields = {
          Cod: 'codigo',
          NºEncargo: 'numero_encargo_formateado',
          FIN: 'inmueble_finalidad',
          Estado: 'estado_texto',
          'Valor Tas': 'valoracion_tasacion',
          'Honor Tas': 'honorarios_tasacion',
          Despl: 'gastos_desplazamiento',
          'Fac Neta': 'facturacion_neta',
          '% Fac Neta': 'facturacion_neta_porcentaje_honorarios',
          Exp: 'expediente',
          Valtin: 'num_valoracion',
          Cli: 'empresa_cliente_nombre',
          'Tas Vis': 'tasador_encargado_codigo',
          'Tas Sal': 'tasador_salidas_codigo',
          'Tas Inc': 'tasador_incidencias_codigo',
          'Tas Ret': 'tasador_retenido_codigo',
          Tra: 'tipo_trabajo_clave',
          Inm: 'tipo_inmueble_clave',
          'Fecha Visado': 'fecha_vistado',
          'Fecha Facturado': 'facturacion_neta_fecha',
        };
      }
      if (this.isStatusN) {
        this.nameExcel = `Export estado Reclamación TAES [${Date.now()}].xls`;
        this.json_fields = {
          Cod: 'codigo',
          A: 'advertencias',
          NºEncargo: 'numero_encargo_formateado',
          Estado: 'estado_texto',
          'Fecha Rec': 'fecha_revision',
          Doc: {
            field: 'tiene_documentacion',
            callback: (value) => {
              if (value) {
                return 'Si';
              }
              return 'No';
            },
          },
          'Tas Vis': 'tasador_encargado_codigo',
          'Tas Sal': 'tasador_salidas_codigo',
          'Tas Inc': 'tasador_incidencias_codigo',
          'Tas Rec': 'tasador_revision_clave',
          Exp: 'expediente',
          Valtin: 'num_valoracion',
          Cli: 'empresa_cliente_nombre',
          'Tas Ret': 'tasador_retenido_codigo',
          Tra: 'tipo_trabajo_clave',
          Inm: 'tipo_inmueble_clave',
          'Fac Neta': 'facturacion_neta',
        };
      }
    },
    toObject(arr) {
      const rv = {};
      for (let i = 0; i < arr.length; ++i) rv[i] = arr[i];
      return rv;
      // Object.defineProperty(rv, arr[i], descriptor)
    },
    removeAllFilters() {
      this.filter.code = '';
      this.filter.chargeNumber = '';
      this.filter.code = '';
      this.filter.valtin = '';
      this.filter.branch = '';
      this.filter.loanNumber = '';
      this.filter.applicant = '';
      this.filter.registro = '';
      this.filter.finca = '';
      this.filter.cadastralReference = '';
      this.filter.poblacion = '';
      this.filter.expediente = undefined;
      this.filter.finalidad = '';
      this.filter.direccion = '';
      this.filter.delegation = '';
      this.filter.dni = '';
      //  this.filterIncidencia = "";
      this.filter.cliente = '';
      this.filter.dateEntrega = '';
      this.loadChargesWithIndicator();
    },
    async loadCharges() {
      const [from = undefined, to = undefined] = this.filter.dateRange || [];
      const [eFrom = undefined, eTo = undefined] = this.filter.dateEntrega || [];
      const [vFrom = undefined, vTo = undefined] = this.filter.dateVisado || []; // Filtro de fecha de visados

      const [fFrom = undefined, fTo = undefined] =
        this.filter.dateRangeFacturado || [];
      const { key = null, order } = this.tableSort;
      const {
        data: { data, current_page: currentPage, per_page: perPage, total },
      } = await chargeAPI.getAll({
        filterStatus: this.filter.status,
        from,
        include: 'solicitante,sucursal,delegacion,empresaCliente,visitas',
        page: this.filter.page,
        perPage: this.perPage,
        search: this.filter.chargeNumber,
        code: this.filter.code,
        filterValtin: this.filter.valtin,
        filterBranch: this.filter.branch,
        filterLoanNumber: this.filter.loanNumber,
        filterApplicantName: this.filter.applicant,
        filterRegistro: this.filter.registro,
        filterFinca: this.filter.finca,
        filterCadastralReference: this.filter.cadastralReference,
        filterPoblacion: this.filter.poblacion,
        filterExpediente: this.filter.expediente,
        filterFinalidad: this.filter.finalidad,
        filterDireccion: this.filter.direccion,
        filterDelegationName: this.filter.delegation,
        filterApplicantNif: this.filter.dni,
        incidencia: this.filterIncidencia,
        filterCliente: this.filter.cliente,
        filterEntrega: this.filter.dateEntrega,
        filterParalizados: this.filterParalizados,
        to,
        fFrom,
        fTo,
        eTo,
        eFrom,
        vTo,
        vFrom,
        sort: key ? `${order === 'descending' ? '-' : ''}${key}` : '',
      });

      this.charges = data.map(({ solicitante = {}, ...c }) => ({
        ...c,
        solicitante_nombre: solicitante ? solicitante.nombre : '',
      }));

      this.filter.page = currentPage;

      this.totalRows = total;
      this.perPage = Number(perPage);
      this.selectedRowId = null;
    },
    async copyCharge() {
      console.log(`Opcion activa en el filtro  ${this.filter.status}`);
      try {
        await chargeAPI.copyCharge(this.checkedRows[0]);
        this.$bfNotify({
          type: 'success',
          title: 'Actualizado',
          message: 'Encargo copiado con éxito',
        });
        this.loadCharges();
        // this.loadChargesWithIndicator();
      } catch (response) {
        this.$bfNotify({
          type: 'error',
          title: 'Error',
          message: 'No se ha podido duplicar con éxito.',
        });
      }
    },
    async loadChargesWithIndicator() {
      this.loadingData = true;
      await this.loadCharges();
      this.loadingData = false;
    },

    async loadAssessorsTableData() {
      const {
        data: { data },
      } = await assessorAPI.getAll({
        perPage: 999,
        active: 1,
        oficial: 0,
        searchCode: this.assesorsTableSearch,
      });

      this.assessorsTableData = data;
    },

    async loadDocumentCategories() {
      const { categorias } = await documentAPI.preCreate();

      this.documentationCategories = categorias;
    },

    async loadChargeStatusCounts() {
      const counts = await chargeAPI.getStatusCounts({
        paralizados: this.filterParalizados,
      });

      this.chargeStatusCounts = Object.keys(counts || {}).map(key => ({
        id: key.toUpperCase(),
        count: counts[key],
      }));
    },

    reloadPageData() {
      this.checkedRows = [];
      this.selectedRowId = null;
      this.loadCharges();
      this.loadChargeStatusCounts();
      this.loadAssessorsTableData();
    },

    applySelectFilters({ value }) {
      this.filterIncidencia = value;
      this.loadChargesWithIndicator();
    },
    applyParalizadosFilter({ value }) {
      this.filterParalizados = value;
      this.loadChargesWithIndicator();
      this.loadChargeStatusCounts();
    },

    clickTableRow({ column, row }) {
      const { id } = row;

      // Ignore form-field cell clicks
      if (
        ['visita_exterior_texto', 'antecedente_texto'].includes(column.property)
      ) {
        return;
      }

      // Ignore form-field cell clicks for "K" status
      if (
        (this.isStatusI || this.isStatusK) &&
        [
          'valoracion_tasacion',
          'honorarios_tasacion',
          'gastos_desplazamiento',
          'facturacion_neta',
          'fecha_visado',
          'facturacion_neta_fecha',
        ].includes(column.property)
      ) {
        return;
      }

      if (this.isStatusB && column.property === 'tiene_documentacion') {
        this.$router.push({
          name: 'charge',
          params: { id: `${id}`, activeTab: 1 },
        });
      } else if (this.isStatusD && column.property === 'estado_texto') {
        this.$router.push({
          name: 'incidencias',
          params: { chargeNumber: row.numero_encargo },
        });
      } else if (this.isStatusJ && column.property === 'estado_texto') {
        this.$router.push({
          name: 'retenidos',
          params: { chargeNumber: row.numero_encargo },
        });
      } else if (this.isStatusN && column.property === 'estado_texto') {
        this.$router.push({
          name: 'revisiones',
          params: { chargeNumber: row.numero_encargo },
        });
      } else if (column.property === 'numero_encargo_formateado') {
        this.$router.push({ name: 'charge', params: { id: `${id}` } });
      } else if (column.property !== 'checkbox') {
        this.selectedRowId = id !== this.selectedRowId ? id : null;
      }

      if (column.property === 'tiene_documentacion') {
        this.$router.push({
          name: 'charge',
          params: { id: `${id}`, activeTab: 1 },
        });
      }
    },

    async updatePagination(newPage) {
      if (!this.loadingData && newPage !== this.filter.page) {
        this.updateQsData({
          page: newPage,
        });
      }
    },

    // eslint-disable-next-line func-names
    updateSearch: debounce(function({ key, value }) {
      if (!this.loadingData) {
        this.updateQsData({
          page: this.page,
          [key]: value,
        });
      }
    }, 800), // original 350

    async updateStatusFilter(optionId) {
      this.filter.dateVisado = undefined; // restore f. visado filter porque solo esta en esa pantalla.
      this.filter.dateRangeFacturado = undefined; // restrore f facturado
      if (!this.loadingData) {
        this.selectedRowId = null;
        this.checkedRows = [];

        this.updateQsData({
          status:
            this.filter.status !== optionId
              ? optionId
              : FILTER_PROPERTIES.status,
          page: 1,
        });
      }
    },

    chargeTableRowCheckboxChange({ value }) {
      const currentIndex = this.checkedRows.indexOf(value);

      if (currentIndex >= 0) {
        this.$delete(this.checkedRows, currentIndex);
      } else {
        this.checkedRows = [...this.checkedRows, value];
      }
    },

    chargesTableHeaderCheckboxChange(value) {
      if (value) {
        this.checkedRows = this.charges.map(c => c.id);
      } else {
        this.checkedRows = [];
      }
    },

    async updateChargesTableCellInput({ key, value }, chargeRow) {
      if (chargeRow[key] !== value) {
        try {
          const { message = '' } = await chargeAPI.update({
            id: chargeRow.id,
            data: {
              [key]: value,
            },
          });

          this.$bfNotify({
            type: 'success',
            title: 'Actualizado',
            message,
          });

          this.loadCharges();
        } catch ({ message = '', errors = {} }) {
          const alertMessage =
            errors && errors[key] ? errors[key].join(' ') : message;

          this.$bfNotify({
            type: 'error',
            title: 'Error',
            message: alertMessage,
          });
        }
      }
    },

    tableRowClassNames({ row }) {
      const classNames = [];

      if (row.urgente === true) {
        classNames.push('urgente-charge-row');
      }

      if (row.id === this.selectedRowId) {
        classNames.push('previewed-charge-row');
      }

      if (row.anulado_pasado === true) {
        classNames.push('anulado-charge-row');
      }

      if (row.tiene_incidencias_inactivas === true) {
        classNames.push('incidencia-inactiva-charge-row');
      }

      return classNames.join(' ');
    },

    async updateCheckedChargesStatuses(newStatus) {
      try {
        await updateMultipleChargeStatuses(this.checkedRows, newStatus);
      } catch ({ message = '' }) {
        this.$bfNotify({
          type: 'error',
          title: 'Error',
          message,
        });
      }
      this.reloadPageData();
    },

    async moveToBStatusWitchCheck() {
      try {
        const { message = '' } = await chargeAPI.moveToBWithValidation(
          this.checkedRows,
        );

        this.$bfNotify({
          type: 'success',
          title: 'Encargos actualizados',
          message,
        });

        this.reloadPageData();
      } catch ({ message = '' }) {
        this.$bfNotify({
          type: 'error',
          title: 'No se ha podido mover a asignación de visitas',
          message,
        });
      }
    },

    async appendCheckedChargesStatuses(appendedStatus) {
      const charges = this.charges.filter(c => this.checkedRows.includes(c.id));
      /* eslint-disable-next-line arrow-parens */
      await updateMultipleChargeStatuses(this.checkedRows, id => {
        const charge = charges.find(c => c.id === id);
        console.log(charge);
        return `${appendedStatus}`;

        // return `${charge.estado}${appendedStatus}`;
      });

      this.reloadPageData();
    },

    async unassignChargeAssessor() {
      await chargeAPI.unassignAssessor(this.checkedRows);

      this.reloadPageData();
    },

    async unassignChargeVisits() {
      const plural = this.checkedRows.length > 1 ? 's' : '';
      const { message = '' } = await chargeAPI.unassignVisits(this.checkedRows);

      this.$bfNotify({
        type: 'success',
        title: `Encargo${plural} actualizado${plural}`,
        message,
      });

      this.reloadPageData();
    },
    async markAsDone() {
      const plural = this.checkedRows.length > 1 ? 's' : '';
      try {
        const message = await visitAPI.setCompleteByAdmin(this.checkedRows);
        this.$bfNotify({
          type: 'success',
          title: `Encargo${plural} actualizado${plural}`,
          message: message.message,
        });
      } catch (erros) {
        this.$bfNotify({
          type: 'warning',
          title: 'algo no salió bien',
          message: 'error',
        });
      }

      this.reloadPageData();
    },
    async unassignExitChargeAssessor() {
      await chargeAPI.unassignAssessorFromExit(this.checkedRows);

      this.reloadPageData();
    },

    documentationFilesAdded(files) {
      this.documentationUploadFiles = files;
      this.displayFileUploadModal = true;
    },

    fileFormModalToggleVisibility(visible) {
      this.documentationFormErrors = {};
      this.displayFileUploadModal = visible;

      if (!visible) {
        this.clearUploadFiles();
      }
    },

    async saveDocumentationFileForm({ titulo, categoria }) {
      try {
        this.documentationIsUploading = true;

        const { notificationPayload } = await uploadChargeDocuments({
          files: this.documentationUploadFiles,
          title: titulo,
          category: categoria,
          chargeId: this.selectedRowId,
          countProgressCallback: (p) => {
            this.documentationCountProgress = p;
          },
          sizeProgressCallback: (p) => {
            this.documentationSizeProgress = p;
          },
        });

        this.$bfNotify(notificationPayload);

        this.displayFileUploadModal = false;
        this.clearUploadFiles();
      } catch ({ errors }) {
        this.documentationFormErrors = errors;
      } finally {
        this.documentationIsUploading = false;
      }
    },

    clearUploadFiles() {
      this.documentationUploadFiles = [];
      this.documentationCountProgress = {};
      this.documentationSizeProgress = {};
      this.$refs.sidePreviewDropzone.$refs.fileDropzone.removeAllFiles();
    },

    assessorTableRowCheckboxChange({ active, value }) {
      this.assessorsTableCheckedRows = active ? [value] : [];
    },

    async assignChargesToAssessor() {
      if (this.areCheckedTableRows) {
        if (this.areCheckedAssessorTableRows) {
          const { message } = await chargeAPI.assignAssessor({
            chargeIds: this.checkedRows,
            assessorId: this.assessorsTableCheckedRows[0],
          });

          this.$bfNotify({
            type: 'success',
            title: 'Asignación correcta',
            message,
          });
        } else {
          /* eslint-disable-next-line arrow-parens */
          const requests = this.checkedRows.map(chargeId => {
            const { tasador_zona_id: tasadorZonaId } = this.charges.find(
              ({ id }) => id === chargeId,
            );

            return chargeAPI.assignAssessor({
              chargeIds: [chargeId],
              assessorId: tasadorZonaId,
            });
          });

          await Promise.all(requests);

          this.$bfNotify({
            type: 'success',
            title: 'Asignación correcta',
          });
        }

        this.checkedRows = [];
        this.assessorsTableCheckedRows = [];

        this.reloadPageData();
      }
    },

    async assignSalidasChargesToAssessor() {
      if (this.areCheckedTableRows && this.areCheckedAssessorTableRows) {
        try {
          const { message = '' } = await chargeAPI.assignAssessorToExit({
            chargeIds: this.checkedRows,
            assessorId: this.assessorsTableCheckedRows[0],
          });

          this.$bfNotify({
            type: 'success',
            title: 'Asignación correcta',
            message,
          });

          this.checkedRows = [];
          this.assessorsTableCheckedRows = [];

          this.loadCharges();
        } catch ({ message = '' }) {
          this.$bfNotify({
            type: 'error',
            title: 'Error',
            message,
          });
        }

        this.checkedRows = [];
        this.assessorsTableCheckedRows = [];

        this.reloadPageData();
      }
    },
    async assignRevisionChargesToAssessor() {
      if (this.areCheckedTableRows && this.areCheckedAssessorTableRows) {
        try {
          const { message = '' } = await chargeAPI.assignAssessorToRevision({
            chargeIds: this.checkedRows,
            assessorId: this.assessorsTableCheckedRows[0],
          });

          this.$bfNotify({
            type: 'success',
            title: 'Asignación correcta',
            message,
          });

          this.checkedRows = [];
          this.assessorsTableCheckedRows = [];

          this.loadCharges();
        } catch ({ message = '' }) {
          this.$bfNotify({
            type: 'error',
            title: 'Error',
            message,
          });
        }

        this.checkedRows = [];
        this.assessorsTableCheckedRows = [];

        this.reloadPageData();
      }
    },

    /* eslint-disable-next-line func-names */
    updateAssesorsTableSearch: debounce(async function() {
      this.searchingAssessors = true;
      try {
        await this.loadAssessorsTableData();
      } finally {
        this.searchingAssessors = false;
      }
    }, 350),

    async toggleSelectedChargesUrgentValue() {
      const requests = this.checkedRows.map(id =>
        chargeAPI.update({
          id,
          data: {
            urgente: !this.selectedTableRowsAreUrgent,
          },
        }),
      );

      const responses = await Promise.all(requests);

      responses.forEach(({ message = '' }, index) => {
        /* The following `setTimeout` is necessary to prevent the
        notifications sometimes overlapping */
        setTimeout(() => {
          this.$bfNotify({
            type: 'success',
            title: 'Encargo Actualizado',
            message,
          });
        }, 10 * index);
      });

      this.reloadPageData();
    },

    openChargeWarningModal() {
      this.displayChargeWarningFormModal = true;
    },

    async updateChargeWarningModal({ key, value }) {
      try {
        const { message = '' } = await chargeAPI.update({
          id: this.checkedRows[0],
          data: {
            [key]: value,
          },
        });

        this.reloadPageData();

        this.$bfNotify({
          type: 'success',
          title: 'Encargo Actualizado',
          message,
        });

        this.displayChargeWarningFormModal = false;
      } catch ({ errors, message = '' }) {
        this.chargeWarningFormErrors = errors;
        this.$bfNotify({
          type: 'error',
          title: 'Error',
          message,
        });
      }
    },

    tableDateFieldValueFormatter(value) {
      return value ? moment(value).format('DD/MM/YYYY') : undefined;
    },

    tablePriceFieldValueFormatter(value) {
      if (typeof value === 'string') {
        return new Intl.NumberFormat('es-ES', {
          style: 'currency',
          currency: 'EUR',
        }).format(value);
      }

      return '';
    },

    async openScheduleVisitModal() {
      if (this.checkedRows) {
        try {
          this.displayScheduleVisitModal = true;
          const { data } = await visitAPI.preCreate(this.checkedRows[0]);
          this.scheduleVisitFormData = {
            ...data,
            duration: 1,
          };
        } catch ({ message = '' }) {
          this.$bfNotify({
            type: 'error',
            title: 'Error',
            message,
          });
        }
      }
    },

    async scheduleChargeVisit({ duration, ...formData }) {
      console.log(`FI${formData.fecha_hora_ini}`);

      const [chargeId] = this.checkedRows;
      const { tasador_encargado_id: tasadorEncargadoId } =
        this.charges.find(c => c.id === chargeId) || {};

      if (tasadorEncargadoId) {
        try {
          const endDate = moment(formData.fecha_hora_ini)
            .add('hours', duration)
            .format('YYYY-MM-DD HH:mm:ss');

          const { message = '' } = await visitAPI.create({
            chargeId,
            data: {
              ...this.scheduleVisitFormData,
              ...formData,
              fecha_hora_fin: endDate,
              tasadores_id: tasadorEncargadoId,
            },
          });

          this.displayScheduleVisitModal = false;
          this.reloadPageData();
          this.scheduleVisitFormData = {};

          this.$bfNotify({
            type: 'success',
            title: 'Visita guardada',
            message,
          });
        } catch ({ message = '' }) {
          this.$bfNotify({
            type: 'error',
            title: 'Error',
            message,
          });
        }
      }
    },
    async updateFilterButtonGroup(optionId) {
      if (this.activeFilterButtons.includes(optionId)) {
        this.activeFilterButtons = this.activeFilterButtons.filter(
          id => id !== optionId,
        );
      } else {
        this.activeFilterButtons = [...this.activeFilterButtons, optionId];
      }

      await this.loadCharges();
    },
    sortTable(data) {
      this.tableSort = data;
      // some fixs on alias keys
      if (data.key === 'numero_encargo_formateado') {
        this.tableSort.key = 'numero_encargo';
      }

      if (data.key === 'visita_exterior_texto') {
        this.tableSort.key = 'inmueble_visita_exterior';
      }

      if (data.key === 'antecedente_texto') {
        this.tableSort.key = 'inmueble_antecedente';
      }

      if (data.key === 'estado_texto') {
        this.tableSort.key = 'estado';
      }

      if (data.key === 'delegacion_nombre') {
        this.tableSort.key = 'delegaciones_id';
      }

      if (data.key === 'empresa_cliente_nombre') {
        this.tableSort.key = 'empresasclientes_id';
      }

      if (data.key === 'zona_nombre') {
        this.tableSort.key = 'zonas_id';
      }
      if (data.key === 'fecha_hora_recepcion_texto') {
        this.tableSort.key = 'fecha_hora_recepcion';
      }

      if (data.key === 'fecha_hora_limite_texto') {
        this.tableSort.key = 'fecha_hora_limite';
      }

      if (data.key === 'tipo_trabajo_clave') {
        this.tableSort.key = 'tipostrabajos_id';
      }

      if (data.key === 'tipo_inmueble_clave') {
        this.tableSort.key = 'tiposinmuebles_id';
      }

      if (data.key === 'sucursal') {
        this.tableSort.key = 'sucursales_id';
      }

      if (data.key === 'solicitante_nombre') {
        this.tableSort.key = 'solicitantes_id';
      }

      if (data.key === 'tasador_encargado_codigo') {
        this.tableSort.key = 'tasador_encargado_id';
      }

      if (data.key === 'tasador_salidas_codigo') {
        this.tableSort.key = 'tasador_salidas_id';
      }

      if (data.key === 'tasador_revision_codigo') {
        this.tableSort.key = 'tasador_revision_id';
      }
      this.reloadPageData();
    },
  },

  computed: {
    ...mapState({
      user: ({ auth }) => auth.user,
    }),

    ...mapGetters('auth', ['isAdmin', 'isColaborador', 'isTasador', 'roles']),

    filterButtonGroupOptions() {
      return [
        {
          label: 'Con Incidencias',
          id: 'incidencias',
        },
      ];
    },

    activeStatusFilterOption() {
      return this.filter.status;
    },

    isStatusA() {
      return this.activeStatusFilterOption === 'A';
    },

    isStatusB() {
      return this.activeStatusFilterOption === 'B';
    },

    isStatusC() {
      return this.activeStatusFilterOption === 'C';
    },
    isStatusD() {
      return this.activeStatusFilterOption === 'D';
    },
    isStatusE() {
      return this.activeStatusFilterOption === 'E';
    },

    isStatusF() {
      return this.activeStatusFilterOption === 'F';
    },

    ifStatusG() {
      return this.activeStatusFilterOption === 'G';
    },
    isStatusG() {
      return this.activeStatusFilterOption === 'G';
    },
    ifStatusH() {
      return this.activeStatusFilterOption === 'H';
    },

    isStatusI() {
      return this.activeStatusFilterOption === 'I';
    },

    isStatusJ() {
      return this.activeStatusFilterOption === 'J';
    },

    isStatusK() {
      return this.activeStatusFilterOption === 'K';
    },
    isStatusL() {
      return this.activeStatusFilterOption === 'L';
    },
    isStatusM() {
      return this.activeStatusFilterOption === 'M';
    },

    isStatusN() {
      return this.activeStatusFilterOption === 'N';
    },

    chargeTableColumns() {
      if (this.isStatusA) {
        return aStatusColumns;
      }

      if (this.isStatusB) {
        return bStatusColumns;
      }

      if (this.activeStatusFilterOption === 'C') {
        return cStatusColumns;
      }

      if (this.isStatusD) {
        return dStatusColumns;
      }

      if (this.activeStatusFilterOption === 'E') {
        return eStatusColumns;
      }

      if (this.isStatusF) {
        return fStatusColumns;
      }

      if (this.isStatusG) {
        return gStatusColumns;
      }

      if (this.ifStatusH) {
        return hStatusColumns;
      }

      if (this.isStatusI) {
        return iStatusColumns;
      }

      if (this.isStatusJ) {
        return jStatusColumns;
      }

      if (this.isStatusK) {
        return kStatusColumns;
      }

      if (this.activeStatusFilterOption === 'L') {
        return lStatusColumns;
      }

      if (this.isStatusM) {
        return mStatusColumns;
      }

      if (this.isStatusN) {
        return nStatusColumns;
      }

      return noFilterStatusColumns;
    },

    assessorsTableColumns() {
      if (this.isTasador) {
        return TasadorRoleassessorsTableColumns;
      }
      return assessorsTableColumns;
    },

    areCheckedTableRows() {
      return !!this.checkedRows.length;
    },

    areCheckedAssessorTableRows() {
      return !!this.assessorsTableCheckedRows.length;
    },

    allTableRowsChecked() {
      return this.charges.reduce(
        (acc, charge) => (acc ? this.checkedRows.includes(charge.id) : false),
        true,
      );
    },

    checkedTableRowsIncludeStatusBE() {
      return (
        this.checkedTableRowsData.findIndex(
          ({ estado }) => estado.includes('B') && estado.includes('E'),
        ) >= 0
      );
    },

    checkedTableRowsIncludeStatusCE() {
      return (
        this.checkedTableRowsData.findIndex(
          ({ estado }) => estado.includes('C') && estado.includes('E'),
        ) >= 0
      );
    },

    checkedTableRowsIncludeStatusLE() {
      return (
        this.checkedTableRowsData.findIndex(
          ({ estado }) => estado.includes('L') && estado.includes('E'),
        ) >= 0
      );
    },

    statusFilterOptions() {
      return [
        {
          label: 'Altas',
          id: 'A',
          leftFooterButtons: [
            {
              label: 'Mover a Asig Visitas ›',
              hidden: !this.areCheckedTableRows,
              // onClick: () => this.updateCheckedChargesStatuses('B'),
              onClick: () => this.moveToBStatusWitchCheck(),
            },
          ],
        },
        {
          label: 'Asig Visitas',
          id: 'B',
          leftFooterButtons: [
            {
              label: 'Meter también en Asig Salidas',
              variant: 'orange',
              hidden:
                this.isTasador ||
                !this.areCheckedTableRows ||
                this.checkedTableRowsIncludeStatusBE,
              onClick: () => this.appendCheckedChargesStatuses('E'),
            },
            {
              label: !this.assessorsTableCheckedRows.length
                ? 'Asignar tasador de zona'
                : 'Asignar tasador seleccionado',
              hidden: !this.areCheckedTableRows,
              onClick: this.assignChargesToAssessor,
            },
          ],
        },
        {
          label: 'Visitas',
          id: 'C',
          leftFooterButtons: [
            {
              label: '‹ Desasignar',
              hidden: !this.areCheckedTableRows,
              variant: 'red',
              onClick: this.unassignChargeAssessor,
            },
            {
              label: 'Meter también en Asig Salidas',
              variant: 'orange',
              hidden:
                this.isTasador ||
                !this.areCheckedTableRows ||
                this.checkedTableRowsIncludeStatusCE,
              onClick: () => this.appendCheckedChargesStatuses('E'),
            },
            {
              label: 'Agendar ›',
              hidden:
                !this.areCheckedTableRows || this.moreThanOneCheckedTableRow,
              onClick: this.openScheduleVisitModal,
            },
          ],
        },
        {
          label: 'En Ruta',
          id: 'L',
          leftFooterButtons: [
            {
              label: 'Meter también en Asig Salidas',
              variant: 'orange',
              hidden:
                this.isTasador ||
                !this.areCheckedTableRows ||
                this.checkedTableRowsIncludeStatusLE,
              onClick: () => this.appendCheckedChargesStatuses('E'),
            },
            {
              label: '‹ Desagendar',
              hidden: !this.areCheckedTableRows,
              variant: 'red',
              onClick: this.unassignChargeVisits,
            },
            {
              label: 'Completar visita',
              hidden: !this.areCheckedTableRows,
              variant: 'orange',
              onClick: this.markAsDone,
            },
          ],
        },
        {
          label: 'Incidencias',
          id: 'D',
        },
        {
          label: 'Asig salidas',
          id: 'E',
          leftFooterButtons: [
            {
              label: '‹ Mover a Asig Visitas',
              variant: 'orange',
              hidden: !this.areCheckedTableRows,
              onClick: () => this.updateCheckedChargesStatuses('B'),
            },
            {
              label: 'Meter también en Asig Visitas',
              variant: 'orange',
              hidden: !this.areCheckedTableRows,
              onClick: () => this.appendCheckedChargesStatuses('BE'),
            },
            {
              label: 'Asignar tasador seleccionado',
              hidden:
                !this.areCheckedTableRows ||
                !this.assessorsTableCheckedRows.length,
              onClick: this.assignSalidasChargesToAssessor,
            },
          ],
        },
        {
          label: 'Salidas',
          id: 'F',
          leftFooterButtons: [
            {
              label: '‹ Desasignar',
              variant: 'red',
              hidden: !this.areCheckedTableRows,
              onClick: this.unassignExitChargeAssessor,
            },
            {
              label: 'Meter también en Asig Visitas',
              variant: 'orange',
              hidden: !this.areCheckedTableRows,
              onClick: () => this.appendCheckedChargesStatuses('BF'),
            },
            {
              label: 'Mover a Revisión y asignar tasador',
              hidden:
                !this.areCheckedTableRows ||
                !this.assessorsTableCheckedRows.length,
              variant: 'primary',
              onClick: this.assignRevisionChargesToAssessor,
            },
            {
              label: 'Salida terminada ›',
              hidden: !this.areCheckedTableRows,
              onClick: () => this.updateCheckedChargesStatuses('H'),
            },
          ],
        },

        {
          label: 'Revisión',
          id: 'G',
          leftFooterButtons: [
            {
              label: '‹ Mover a Asig Visitas',
              variant: 'orange',
              hidden: !this.areCheckedTableRows,
              onClick: () => this.updateCheckedChargesStatuses('B'),
            },
            {
              label: '‹ Mover a Asig Salidas',
              variant: 'orange',
              hidden: !this.areCheckedTableRows,
              onClick: () => this.updateCheckedChargesStatuses('E'),
            },
            {
              label: '‹ Mover a Salidas',
              variant: 'orange',
              hidden: !this.areCheckedTableRows,
              onClick: () => this.updateCheckedChargesStatuses('F'),
            },
            {
              label: 'Revisado ›',
              hidden: !this.areCheckedTableRows,
              onClick: () => this.updateCheckedChargesStatuses('H'),
            },
          ],
        },
        {
          label: 'Enviar',
          id: 'H',
          leftFooterButtons: [
            {
              label: 'Enviar ›',
              hidden: !this.areCheckedTableRows,
              onClick: () => this.updateCheckedChargesStatuses('I'),
            },
          ],
        },
        {
          label: 'Terminados',
          id: 'I',
          leftFooterButtons: [
            {
              label: 'Visar ›',
              hidden: !this.areCheckedTableRows,
              onClick: () => this.updateCheckedChargesStatuses('K'),
            },
          ],
        },
        {
          label: 'Retenidos',
          id: 'J',
        },
        {
          label: 'Visados',
          id: 'K',
          leftFooterButtons: [
            {
              label: 'Facturar ›',
              hidden: !this.areCheckedTableRows,
              onClick: () => this.updateCheckedChargesStatuses('M'),
            },
          ],
        },
        {
          label: 'Facturado',
          id: 'M',
        },
        {
          label: 'Reclamación', // antiguo rev. tasador
          id: 'N',
          leftFooterButtons: [
            {
              label: '‹ Enviar a Visados',
              hidden: !this.areCheckedTableRows,
              onClick: () => this.updateCheckedChargesStatuses('K'),
            },
            {
              label: '‹ Enviar a Facturado',
              hidden: !this.areCheckedTableRows,
              onClick: () => this.updateCheckedChargesStatuses('M'),
            },
          ],
        },
      ].filter(({ id }) => {
        if (this.isAdmin) {
          return true;
        }

        if (this.isColaborador) {
          return COLABORADOR_ALLOWED_FILTERS.includes(id);
        }

        return TASADOR_ALLOWED_FILTERS.includes(id);
      });
    },

    statusFilterButtonOptions() {
      return this.statusFilterOptions.map(({ label, id }) => {
        const { count = '' } = this.chargeStatusCounts.length
          ? this.chargeStatusCounts.find(status => status.id === id) || {}
          : {};

        return {
          label,
          id,
          ...(count !== '' ? { additional: `${count}` } : {}),
        };
      });
    },

    displayTableSidebar() {
      return this.displayTasadoresSideTable || this.displaySidePreview;
    },

    displayTasadoresSideTable() {
      return (
        ['B', 'E', 'F'].includes(this.activeStatusFilterOption) &&
        this.areCheckedTableRows
      );
    },

    displaySidePreview() {
      return !!this.selectedRowId;
    },

    toolbarLeftButtons() {
      const globalButtons = [
        {
          label: `${
            this.selectedTableRowsAreUrgent ? 'Desmarcar' : 'Marcar'
          } como Urgente`,
          variant: 'red',
          hidden: !this.areCheckedTableRows,
          onClick: this.toggleSelectedChargesUrgentValue,
        },
        {
          label: 'Crear aviso',
          variant: 'primary',
          hidden: !this.areCheckedTableRows || this.checkedRows.length > 1,
          onClick: this.openChargeWarningModal,
        },
        {
          label: 'Copiar encargo',
          hidden:
            !this.areCheckedTableRows ||
            this.checkedRows.length > 1 ||
            this.filter.status === 'B' ||
            this.filter.status === 'C' ||
            this.filter.status === 'D' ||
            this.filter.status === 'E' ||
            this.filter.status === 'F' ||
            this.filter.status === 'G' ||
            this.filter.status === 'H' ||
            this.filter.status === 'I' ||
            this.filter.status === 'J' ||
            this.filter.status === 'K' ||
            this.filter.status === 'L' ||
            this.filter.status === 'M' ||
            this.filter.status === 'N',
          onClick: this.copyCharge,
        },
      ];

      const selectedStatus = this.statusFilterOptions.find(
        status => status.id === this.activeStatusFilterOption,
      );

      return [
        ...globalButtons,
        ...((selectedStatus && selectedStatus.leftFooterButtons) || []),
      ].filter(b => !b.hidden);
    },

    showNewIncidentButton() {
      return (
        this.areCheckedTableRows &&
        !this.moreThanOneCheckedTableRow &&
        ['A', 'B', 'C', 'L', 'D', 'E', 'F', 'G', 'H'].includes(
          this.activeStatusFilterOption,
        )
      );
    },

    showCreateRetentionButton() {
      return (
        this.areCheckedTableRows &&
        !this.moreThanOneCheckedTableRow &&
        ['I'].includes(this.activeStatusFilterOption)
      );
    },

    showCreateRevisionButton() {
      return (
        this.areCheckedTableRows &&
        !this.moreThanOneCheckedTableRow &&
        ['K', 'M'].includes(this.activeStatusFilterOption)
      );
    },

    showToolbarRightButton() {
      return (
        this.showNewIncidentButton ||
        this.showCreateRevisionButton ||
        this.showCreateRetentionButton
      );
    },

    moreThanOneCheckedTableRow() {
      return this.checkedRows.length !== 1;
    },

    selectedTableRowData() {
      return this.charges.find(({ id }) => id === this.selectedRowId);
    },

    checkedTableRowsData() {
      if (this.checkedRows.length) {
        return this.checkedRows.map(rowId =>
          this.charges.find(({ id }) => id === rowId),
        );
      }

      return [];
    },

    selectedTableRowsAreUrgent() {
      if (this.checkedTableRowsData && !!this.checkedTableRowsData.length) {
        return this.checkedTableRowsData.reduce(
          (acc, item) => (acc && !item.urgente ? item.urgente : acc),
          true,
        );
      }

      return false;
    },

    documentationFormData() {
      if (this.documentationUploadFiles.length > 0) {
        return {
          titulo: !this.multipleUploadFiles
            ? this.documentationUploadFiles[0].name
            : '',
        };
      }

      return {};
    },

    multipleUploadFiles() {
      return this.documentationUploadFiles.length > 1;
    },

    showChargesToolbar() {
      return (
        !this.loadingData &&
        (!!this.toolbarLeftButtons.length || this.showToolbarRightButton)
      );
    },

    selectedChargeWarningValue() {
      if (
        this.areCheckedTableRows &&
        !this.moreThanOneCheckedTableRow &&
        this.checkedTableRowsData.length
      ) {
        return this.checkedTableRowsData[0].advertencias || '';
      }

      return '';
    },

    chargesTableTrueFalseSelectOptions() {
      return [
        {
          label: 'Si',
          value: true,
        },
        {
          label: 'No',
          value: false,
        },
      ];
    },
  },

  components: {
    ChargeSidePreview,
    ChargesToolbar,
    ChargeWarningModal,
    FileDropzone,
    FileFormModal,
    LoadingIndicator,
    PageWrap,
    ScheduleVisitModal,
  },
};
</script>

<style lang="scss" scoped src="./styles.scss" />
<style>
.date-small {
  min-width: unset !important;
}
.date-small div {
  width: 120px;
}
.duplicate-btn {
  margin-right: 1em !important;
}

.btn-exportar {
  background: var(--bf-color-primary);
  color: white;
  display: inline-block;
  color: var(--bf-color-light);
  background: var(--bf-color-primary);
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border: 0;
  margin: 0;
  padding: 7px 15px;
  border-radius: 9999px;
  font-size: var(--bf-font-size-body);
  font-weight: var(--bf-font-weight-semibold);
  text-align: center;
  cursor: pointer;
  outline: none;
  text-shadow: 0 0 1px var(--bf-color-dark--25);
  -webkit-transition: opacity 0.2s ease, background 0.2s ease;
  transition: opacity 0.2s ease, background 0.2s ease;
}
.btn-exportar:hover {
  color: White;
  background: var(--bf-color-primary--dark);
}
.anulado-charge-row td {
  background-color: rgba(102, 238, 219, 0.49);
}
.incidencia-inactiva-charge-row td {
  background-color: rgba(196, 94, 142, 0.49);
}
</style>
